import React from 'react';
import { Band, Money, type LedgerCollapse } from '@billda/design-system';

export interface DeductionGroupHeaderProps {
  groupName: string;
  count: number;
  totalAmount: number;
  expanded: boolean;
  onToggle: () => void;
  collapse: LedgerCollapse;
  'data-testid'?: string;
  panelId?: string;
}

export const DeductionGroupHeader = React.memo(function DeductionGroupHeader({
  groupName,
  count,
  totalAmount,
  expanded,
  onToggle,
  collapse,
  'data-testid': dataTestId,
  panelId,
}: DeductionGroupHeaderProps) {
  return (
    <Band
      collapse={collapse}
      primary={groupName}
      count={count}
      trailing={<Money value={totalAmount} />}
      open={expanded}
      onToggle={onToggle}
      showActions
      panelId={panelId}
      data-testid={dataTestId}
    />
  );
});
